import { useReactiveVar } from '@apollo/client';
import { Checkbox } from 'components/shared/checkbox';
import { DefaultTextInput } from 'components/shared/form';
import { ExternalLink } from 'components/shared/link/ExternalLink';
import { GraphikMediumTextLg, GraphikTextSm } from 'components/shared/styled';
import { FunctionComponent } from 'react';
import { Controller } from 'react-hook-form';
import { View } from 'react-native';
import Styles from 'style';
import useTailwindResponsive from 'utilities/TailwindResponsive';
import { signUpFormvar } from '../form';

export const TermsFormStep: FunctionComponent = () => {
  const { TailwindResponsive } = useTailwindResponsive();

  const form = useReactiveVar(signUpFormvar);

  return (
    <>
      <GraphikMediumTextLg
        color={Styles.Colours.Light1}
        style={TailwindResponsive(`mb-8`)}
      >
        Almost done!
      </GraphikMediumTextLg>

      <View style={TailwindResponsive('w-128 mobWeb:w-full')}>
        <Controller
          control={form?.control}
          name="reference"
          render={({ field: { onChange, value, ref } }) => (
            <DefaultTextInput
              color={Styles.Colours.Light1}
              handleChange={(input) => {
                form?.clearErrors('reference');
                onChange(input);
              }}
              inputRef={ref}
              label="How did you hear about Fairchain?"
              value={value}
            />
          )}
        />
      </View>

      <View style={TailwindResponsive('mt-8 w-2/5 mobWeb:w-full')}>
        <View style={TailwindResponsive(`mb-2 flex flex-row items-center`)}>
          <Controller
            control={form?.control}
            name="agreedToTerms"
            render={({ field: { onChange, value } }) => (
              <>
                <Checkbox
                  checkColor={Styles.Colours.Light1}
                  isChecked={value}
                  onPress={() => {
                    onChange(!value);
                  }}
                  size={18}
                />
                <GraphikTextSm color={Styles.Colours.Light1}>
                  I accept the Fairchain{' '}
                  <ExternalLink link="/terms">
                    <GraphikTextSm
                      style={TailwindResponsive(`text-Light1 underline`)}
                    >
                      Terms of Service
                    </GraphikTextSm>
                  </ExternalLink>
                  .
                </GraphikTextSm>
              </>
            )}
          />
        </View>
        <GraphikTextSm style={TailwindResponsive(`text-Error`)}>
          {form?.formState?.errors?.agreedToTerms?.message}
        </GraphikTextSm>
      </View>
    </>
  );
};
